<template>
  <div class="row">
    <div class="col-xxl-8">
      <div
        class="card mb-25 border-0 rounded-0 bg-white checkout-box letter-spacing radius-7"
      >
        <div class="card-body">
          <ul
            class="nav nav-tabs bg-white border-0 rounded-0 radius-7"
            id="myTab"
            role="tablist"
          >

            <li class="nav-item" role="presentation">
              <button
                class="nav-link fs-14 fs-md-15 fs-lg-16 fw-bold position-relative border-0 rounded-0 d-block w-100 active radius-7"
                id="payment-method-tab"
                data-bs-toggle="tab"
                data-bs-target="#payment-method-tab-pane"
                type="button"
                role="tab"
                aria-controls="payment-method-tab-pane"
                aria-selected="true"
              >
                <i class="flaticon-atm"></i>
                Mês atual
              </button>
            </li>

            <li class="nav-item" role="presentation">
              <button
                class="nav-link fs-14 fs-md-15 fs-lg-16 fw-bold position-relative border-0 rounded-0 d-block w-100 radius-7"
                id="place-order-tab"
                data-bs-toggle="tab"
                data-bs-target="#place-order-tab-pane"
                type="button"
                role="tab"
                aria-controls="place-order-tab-pane"
                aria-selected="false"
              >
                <i class="flaticon-calendar"></i>
                Histórico
              </button>
            </li>

          </ul>

          <div
            class="tab-content p-15 p-sm-20 p-md-25 p-lg-30"
            id="myTabContent"
          >
            <div
              class="tab-pane fade show active"
              id="payment-method-tab-pane"
              role="tabpanel"
              tabindex="0"
            >
              <div id="paymentAccordion">
                <div class="accordion-item rounded-0 radius-7">

                    <div class="current-invoice">
                      <div class="d-flex flex-column flex-md-row justify-content-between align-items-start gap-3 mb-20">
                        <div>
                          <span class="text-uppercase fw-medium text-body-tertiary fs-13">
                            Fatura do mês atual
                          </span>
                          <h4 class="mb-0 mt-5 fw-bold text-black current-invoice__title">
                            {{ hasCurrentInvoice ? formattedInvoiceReference : 'Nenhuma fatura disponível' }}
                          </h4>
                        </div>
                        <span
                          v-if="hasCurrentInvoice"
                          class="badge current-invoice__badge"
                          :class="invoiceStatusClass"
                        >
                          {{ invoiceStatusLabel }}
                        </span>
                      </div>

                      <div v-if="isLoadingSummary" class="current-invoice__empty">
                        Carregando fatura...
                      </div>

                      <div v-else-if="hasCurrentInvoice" class="current-invoice__content">
                        <div class="current-invoice__amount">
                          <span class="text-muted fs-14">{{ invoiceTypeLabel }}</span>
                          <strong>R$ {{ formattedInvoiceValue }}</strong>
                          <small>{{ invoiceTypeDescription }}</small>
                        </div>

                        <div class="current-invoice__details">
                          <div>
                            <span class="text-muted fs-13">Referente a</span>
                            <strong>{{ invoiceTypeLabel }}</strong>
                          </div>
                          <div>
                            <span class="text-muted fs-13">Referência</span>
                            <strong>{{ formattedInvoiceReference }}</strong>
                          </div>
                          <div>
                            <span class="text-muted fs-13">Status</span>
                            <strong>{{ invoiceStatusLabel }}</strong>
                          </div>
                          <div v-if="isInvoicePaid">
                            <span class="text-muted fs-13">Pagamento realizado em</span>
                            <strong>{{ getSummary.date_payment_formatted || 'Data não informada' }}</strong>
                          </div>
                        </div>

                        <div v-if="isInvoicePaid" class="current-invoice__notice current-invoice__notice--success">
                          Esta fatura já foi paga. Obrigado por manter sua assinatura em dia.
                        </div>

                        <div v-else class="current-invoice__actions">
                          <a
                            v-if="getSummary.payment_url"
                            :href="getSummary.payment_url"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block text-decoration-none"
                          >
                            Pagar fatura
                            <i class="flaticon-right-arrow ms-5 fs-12"></i>
                          </a>
                          <div v-else class="current-invoice__notice">
                            O link de pagamento ainda não está disponível para esta fatura.
                          </div>
                        </div>
                      </div>

                      <div v-else class="current-invoice__empty">
                        <template v-if="getTrial">
                          {{ getTrial.active ? 'Seu teste grátis está ativo. Nenhum pagamento é necessário agora.' : 'Seu teste terminou. A cobrança segue o ciclo mensal.' }}
                          Primeira cobrança: {{ trialBillingDate }}.
                        </template>
                        <template v-else>Não há faturas disponíveis no momento.</template>
                      </div>
                    </div>

                </div>
              </div>
            </div>

            <div
              class="tab-pane fade"
              id="place-order-tab-pane"
              role="tabpanel"
              tabindex="0"
            >
              <div id="paymentAccordion">
                <div class="accordion-item rounded-0 radius-7">
                  <PaymentHistory />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="col-xxl-4">
      <div
        class="card mb-25 border-0 rounded-0 bg-white order-summary-box letter-spacing radius-7 subscription-plan-card"
      >
        <div class="card-head bg-white d-flex align-items-center card-checkout-title">
          
          <i class="flaticon-user font-22 color-font-general"></i>
          <h5 class="mb-0 fw-bold text-black ms-10 ms-md-15 font-16 color-font-general">
            Plano contratado
          </h5>

        </div>
        <div class="card-body content-checkout-style subscription-plan-card__body">
          <div v-if="getLoadingCurrentPlan" class="subscription-plan-card__empty">
            Carregando plano...
          </div>

          <div v-else-if="currentPlan" class="subscription-plan-card__current">
            <div class="d-flex align-items-start justify-content-between gap-3">
              <div>
                <span class="text-uppercase fw-medium text-body-tertiary fs-13">
                  Plano atual
                </span>
                <h4 class="mb-0 mt-5 fw-bold text-black subscription-plan-card__title">
                  {{ currentPlanName }}
                </h4>
                <p class="subscription-plan-card__description">
                  {{ currentPlanDescription }}
                </p>
              </div>
              <span class="subscription-plan-card__badge">
                Ativo
              </span>
            </div>

            <div class="subscription-plan-card__price">
              <strong>{{ formatPlanPrice(currentPlan) }}</strong>
              <span>{{ currentPlanBillingCycle }}</span>
            </div>

            <ul v-if="currentPlanFeatures.length" class="subscription-plan-card__features">
              <li v-for="(feature, index) in currentPlanFeatures" :key="index">
                <i class="flaticon-check-mark"></i>
                <span>{{ feature }}</span>
              </li>
            </ul>

            <button
              type="button"
              class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 rounded-1 bg-success fs-md-15 fs-lg-16 w-100"
              @click="togglePlanSelection"
            >
              {{ showPlanSelection ? 'Fechar opções' : 'Mudar plano' }}
              <i class="flaticon-right-arrow ms-5 fs-12"></i>
            </button>
          </div>

          <div v-else class="subscription-plan-card__empty">
            {{ getErrorCurrentPlan || 'Nenhum plano contratado encontrado.' }}
          </div>

          <div v-if="showPlanSelection" class="subscription-plan-card__options">
            <p v-if="getTrial?.active" class="text-success">Durante o teste, a troca é gratuita e mantém a mesma data de término.</p>
            <div class="subscription-plan-card__options-title">
              Escolha um novo plano
            </div>

            <div v-if="getLoadingAvailablePlans" class="subscription-plan-card__empty">
              Carregando planos...
            </div>

            <div v-else-if="otherPlans.length" class="subscription-plan-card__list">
              <div
                v-for="plan in otherPlans"
                :key="plan.id"
                class="subscription-plan-card__option"
              >
                <div>
                  <h6 class="mb-5 fw-bold text-black">
                    {{ plan.name || plan.title || 'Plano' }}
                  </h6>
                  <p class="subscription-plan-card__option-description">
                    {{ formatPlanDescription(plan) }}
                  </p>
                  <div class="subscription-plan-card__option-price">
                    {{ formatPlanPrice(plan) }}
                    <span>{{ formatPlanBillingCycle(plan) }}</span>
                  </div>
                </div>
                <button
                  type="button"
                  class="btn btn-outline-success btn-sm"
                  :disabled="getLoadingChangePlan"
                  @click="changePlan(plan)"
                >
                  {{ getLoadingChangePlan && selectedPlanId === plan.id ? 'Trocando...' : 'Trocar' }}
                </button>
              </div>
            </div>

            <div v-else class="subscription-plan-card__empty">
              {{ getErrorAvailablePlans || 'Não há outros planos disponíveis para troca.' }}
            </div>

            <div v-if="getErrorChangePlan" class="subscription-plan-card__feedback subscription-plan-card__feedback--error">
              {{ getErrorChangePlan }}
            </div>
            <div v-if="getSuccessChangePlan" class="subscription-plan-card__feedback subscription-plan-card__feedback--success">
              {{ getSuccessChangePlan }}
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7 payment-contact-card">
        <div class="payment-contact-card__header">
          <i class="ph ph-headset"></i>
          <h5 class="mb-0 fw-bold text-black font-16 color-font-general">
            Contato financeiro
          </h5>
        </div>

        <div class="payment-contact-card__body">
          <p>
            Precisa de ajuda com sua fatura, plano ou regularização do acesso?
          </p>

          <a class="payment-contact-card__item" href="mailto:contato@sanvault.com.br">
            <span class="payment-contact-card__icon">
              <i class="ph ph-envelope-simple"></i>
            </span>
            <span>
              <small>E-mail</small>
              <strong>contato@sanvault.com.br</strong>
            </span>
          </a>

          <a
            class="payment-contact-card__item payment-contact-card__item--whatsapp"
            href="https://wa.me/5511915100084"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span class="payment-contact-card__icon">
              <i class="ph ph-whatsapp-logo"></i>
            </span>
            <span>
              <small>WhatsApp</small>
              <strong>(11) 9 1510-0084</strong>
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PaymentHistory from "./PaymentHistory.vue";
import moment from 'moment';

export default {
  name: "CheckoutContent",
  components: {
    PaymentHistory
  },
  data() {
    return {
      stripe: null,
      cardElement: null,
      isLoadingSummary: true,
      showPlanSelection: false,
      selectedPlanId: null,
      form: {
        name: '',
        email: '',
        company_id: ''
      }
    };
  },
  async mounted() {
    this.setInvoiceHistory();
    await Promise.all([
      this.setSummary(),
      this.setCurrentPlan(),
      this.setAvailablePlans(),
    ]);
    this.isLoadingSummary = false;
  },
  computed:{
    ...mapGetters([
      "getSummary",
      "getErrorPayment",
      "getSuccessPayment",
      "getPaymentModeDefault",
      "getLoadingPaymentMode",
      "getCurrentPlan",
      "getTrial",
      "getAvailablePlans",
      "getLoadingCurrentPlan",
      "getLoadingAvailablePlans",
      "getLoadingChangePlan",
      "getErrorCurrentPlan",
      "getErrorAvailablePlans",
      "getErrorChangePlan",
      "getSuccessChangePlan"
    ]),
    hasCurrentInvoice() {
      return !!(this.getSummary && this.getSummary.id);
    },
    trialBillingDate() { return this.getTrial ? new Date(`${this.getTrial.first_billing_date}T12:00:00`).toLocaleDateString('pt-BR') : ''; },
    isInvoicePaid() {
      return this.getSummary && this.getSummary.status === 'paid';
    },
    invoiceStatusLabel() {
      if (!this.getSummary || !this.getSummary.status) {
        return 'Indisponível';
      }

      const statusLabels = {
        paid: 'Paga',
        pending: 'Pendente',
        overdue: 'Vencida',
        canceled: 'Cancelada',
      };

      return statusLabels[this.getSummary.status] || this.getSummary.status;
    },
    invoiceStatusClass() {
      if (this.isInvoicePaid) {
        return 'current-invoice__badge--paid';
      }

      if (this.getSummary && this.getSummary.status === 'overdue') {
        return 'current-invoice__badge--overdue';
      }

      return 'current-invoice__badge--pending';
    },
    formattedInvoiceValue() {
      if (!this.getSummary) {
        return '0,00';
      }

      return this.getSummary.value_formatted || String(this.getSummary.value || '0,00').replace('.', ',');
    },
    formattedInvoiceReference() {
      if (!this.getSummary || !this.getSummary.month || !this.getSummary.year) {
        return '';
      }

      const months = [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ];
      const monthName = String(months && this.getSummary.month).padStart(2, '0');

      return `${monthName}/${this.getSummary.year}`;
    },
    invoiceTypeLabel() {
      if (!this.getSummary || !this.getSummary.invoice_type) {
        return 'Fatura mensal';
      }

      const invoiceTypeLabels = {
        monthly: 'Fatura mensal',
        plan_change: 'Troca de plano',
      };

      return invoiceTypeLabels[this.getSummary.invoice_type] || this.getSummary.invoice_type;
    },
    invoiceTypeDescription() {
      const invoiceType = this.getSummary ? this.getSummary.invoice_type : 'monthly';
      const descriptions = {
        monthly: `Referente ao sistema de agendamento da competência ${this.formattedInvoiceReference}.`,
        plan_change: `Referente à troca de plano do sistema de agendamento na competência ${this.formattedInvoiceReference}.`,
      };

      return descriptions[invoiceType] || `Referente ao sistema de agendamento da competência ${this.formattedInvoiceReference}.`;
    },
    summaryProductTitle() {
      return this.hasCurrentInvoice ? 'Valor da fatura' : 'Valor do Sistema';
    },
    summaryProductSubtitle() {
      return this.hasCurrentInvoice ? this.formattedInvoiceReference : 'Sem fatura disponível';
    },
    summaryProductValue() {
      return this.hasCurrentInvoice ? `R$ ${this.formattedInvoiceValue}` : 'Indisponível';
    },
    currentPlan() {
      const payload = this.getCurrentPlan;

      if (!payload) {
        return null;
      }

      return payload.plan || payload.current_plan || payload.data || payload;
    },
    availablePlans() {
      const payload = this.getAvailablePlans;

      if (!payload) {
        return [];
      }

      if (Array.isArray(payload)) {
        return payload;
      }

      if (Array.isArray(payload.data)) {
        return payload.data;
      }

      if (Array.isArray(payload.plans)) {
        return payload.plans;
      }

      return [];
    },
    otherPlans() {
      if (!this.currentPlan || !this.currentPlan.id) {
        return this.availablePlans;
      }

      return this.availablePlans.filter((plan) => plan.id !== this.currentPlan.id);
    },
    currentPlanName() {
      return this.currentPlan.name || this.currentPlan.title || 'Plano';
    },
    currentPlanDescription() {
      return this.formatPlanDescription(this.currentPlan);
    },
    currentPlanBillingCycle() {
      return this.formatPlanBillingCycle(this.currentPlan);
    },
    currentPlanFeatures() {
      const features = this.currentPlan.features || this.currentPlan.benefits || [];

      if (Array.isArray(features)) {
        return features.map((feature) => {
          if (typeof feature === 'string') {
            return feature;
          }

          return feature.name || feature.description || '';
        }).filter(Boolean);
      }

      return [];
    }
  },
  methods: {
    ...mapActions([ 
      "setSummary",
      "setInvoiceHistory",
      "setCurrentPlan",
      "setAvailablePlans",
      "setChangePlan",
    ]),
    togglePlanSelection() {
      this.showPlanSelection = !this.showPlanSelection;
    },
    formatPlanDescription(plan) {
      if (!plan) {
        return '';
      }

      return plan.description
        || plan.short_description
        || plan.subtitle
        || plan.resume
        || plan.summary
        || 'Plano pensado para acompanhar a rotina do seu negócio com recursos essenciais para gestão e crescimento.';
    },
    formatPlanPrice(plan) {
      if (!plan) {
        return 'Indisponível';
      }

      if (plan.price_formatted) {
        return plan.price_formatted.indexOf('R$') === 0 ? plan.price_formatted : `R$ ${plan.price_formatted}`;
      }

      if (plan.value_formatted) {
        return plan.value_formatted.indexOf('R$') === 0 ? plan.value_formatted : `R$ ${plan.value_formatted}`;
      }

      const rawValue = plan.price || plan.value || plan.amount;

      if (rawValue === undefined || rawValue === null || rawValue === '') {
        return 'Indisponível';
      }

      const numericValue = Number(rawValue);

      if (Number.isNaN(numericValue)) {
        return `R$ ${String(rawValue).replace('.', ',')}`;
      }

      return numericValue.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    },
    formatPlanBillingCycle(plan) {
      if (!plan) {
        return '';
      }

      const cycle = plan.billing_cycle || plan.interval || plan.period || plan.recurrence;
      const cycleLabels = {
        month: '/mês',
        monthly: '/mês',
        mes: '/mês',
        mês: '/mês',
        year: '/ano',
        yearly: '/ano',
        ano: '/ano',
      };

      return cycleLabels[cycle] || cycle || '/mês';
    },
    async changePlan(plan) {
      if (!plan || !plan.id || this.getLoadingChangePlan) {
        return;
      }

      this.selectedPlanId = plan.id;
      const changed = await this.setChangePlan(plan.id);
      this.selectedPlanId = null;

      if (changed) {
        this.showPlanSelection = false;
      }
    },
    convertTime(time) {
      const totalSeconds = Math.max(0, Math.floor(Number(time) || 0)); // lida com "96000.01243"
      const d = moment.duration(totalSeconds, 'seconds');

      const hours = Math.floor(d.asHours()); // horas **totais**, não %24
      const minutes = d.minutes();
      const seconds = d.seconds();

      const pad = (n) => String(n).padStart(2, '0');
      return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`; // ex.: 26:40:00
    }
  }
};
</script>
<style scoped>
.border-dashed{
  border-bottom: 1px dashed #ccc !important;
}
/* Estilo para o formulário */
#payment-form {
  max-width: 400px;
  margin: auto;
}

#payment-form label {
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
}

#payment-form input[type="text"],
#payment-form input[type="email"],
#payment-form input[type="radio"] {
  width: 100%;
  padding: 8px;
  margin-bottom: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

/* Estilo para o botão de envio */
#payment-form button {
  width: 100%;
  padding: 10px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

#payment-form button:hover {
  background-color: #45a049;
}

/* Estilo para o elemento do cartão */
.stripe-card-element {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 16px;
}

/* Estilos para estados do elemento do cartão */
.stripe-card-element input {
  font-size: 16px;
}

.stripe-card-element .StripeElement--invalid {
  border-color: #fa755a;
}

.stripe-card-element .StripeElement--focus {
  border-color: #4CAF50;
}

/* Estilo específico para o campo de número do cartão */
.InputElement {
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  margin-bottom: 16px;
  background-color: #45a049 !;
}

.InputElement:focus {
  border-color: #4CAF50;
  outline: none;
}

.InputElement--invalid {
  border-color: #fa755a;
}

.InputElement--focus {
  border-color: #4CAF50;
}

.InputElement{
  background-color: #45a049;
}



.card-element {
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 10px;
}

#card-errors {
  color: #fa755a;
}

.current-invoice {
  padding: 4px 0;
}

.current-invoice__title {
  font-size: 22px;
}

.current-invoice__badge {
  border-radius: 4px;
  font-size: 13px;
  padding: 8px 12px;
}

.current-invoice__badge--paid {
  background-color: rgba(25, 135, 84, 0.12);
  color: #198754;
}

.current-invoice__badge--pending {
  background-color: rgba(255, 193, 7, 0.18);
  color: #8a6400;
}

.current-invoice__badge--overdue {
  background-color: rgba(220, 53, 69, 0.12);
  color: #dc3545;
}

.current-invoice__content {
  border: 1px solid #f2f1f9;
  border-radius: 7px;
  padding: 18px;
}

.current-invoice__amount {
  align-items: flex-start;
  border-bottom: 1px solid #f2f1f9;
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 18px;
  padding-bottom: 18px;
}

.current-invoice__amount strong {
  color: #111827;
  font-size: 32px;
  line-height: 1;
}

.current-invoice__amount small {
  color: #656f7d;
  font-size: 13px;
  line-height: 1.4;
}

.current-invoice__details {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  margin-bottom: 18px;
}

.current-invoice__details div {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.current-invoice__notice,
.current-invoice__empty {
  background-color: #f8f9fb;
  border: 1px solid #f2f1f9;
  border-radius: 7px;
  color: #656f7d;
  padding: 14px 16px;
}

.current-invoice__notice--success {
  background-color: rgba(25, 135, 84, 0.08);
  border-color: rgba(25, 135, 84, 0.18);
  color: #146c43;
}

.current-invoice__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.order-summary-box.subscription-plan-card {
  overflow: hidden;
  padding-top: 0 !important;
}

.order-summary-box.subscription-plan-card .card-checkout-title {
  border-bottom: 0 !important;
  height: 70px;
  padding: 0 28px;
}

.order-summary-box.subscription-plan-card .content-checkout-style {
  margin-top: 0 !important;
}

.order-summary-box.subscription-plan-card .subscription-plan-card__body {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 26px 28px 28px !important;
}

.subscription-plan-card__current {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.subscription-plan-card__title {
  font-size: 22px;
}

.subscription-plan-card__description {
  color: #656f7d;
  font-size: 14px;
  line-height: 1.45;
  margin: 8px 0 0;
  max-width: 280px;
}

.subscription-plan-card__badge {
  background-color: rgba(25, 135, 84, 0.12);
  border-radius: 4px;
  color: #198754;
  font-size: 13px;
  font-weight: 600;
  padding: 7px 10px;
}

.subscription-plan-card__price {
  background-color: #f8f9fb;
  border: 1px solid #f2f1f9;
  border-radius: 7px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px;
}

.subscription-plan-card__price strong {
  color: #111827;
  font-size: 28px;
  line-height: 1;
}

.subscription-plan-card__price span,
.subscription-plan-card__option-price span {
  color: #656f7d;
  font-size: 13px;
}

.subscription-plan-card__features {
  display: flex;
  flex-direction: column;
  gap: 10px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.subscription-plan-card__features li {
  align-items: flex-start;
  color: #4b5563;
  display: flex;
  gap: 8px;
  line-height: 1.4;
}

.subscription-plan-card__features i {
  color: #198754;
  font-size: 13px;
  margin-top: 2px;
}

.subscription-plan-card__options {
  border-top: 1px solid #f2f1f9;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 18px;
}

.subscription-plan-card__options-title {
  color: #111827;
  font-size: 15px;
  font-weight: 700;
}

.subscription-plan-card__list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.subscription-plan-card__option {
  align-items: flex-start;
  border: 1px solid #f2f1f9;
  border-radius: 7px;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding: 14px;
}

.subscription-plan-card__option-description {
  color: #656f7d;
  font-size: 13px;
  line-height: 1.4;
  margin: 0 0 10px;
}

.subscription-plan-card__option-price {
  color: #111827;
  display: flex;
  flex-direction: column;
  font-weight: 700;
  gap: 3px;
}

.subscription-plan-card__empty,
.subscription-plan-card__feedback {
  background-color: #f8f9fb;
  border: 1px solid #f2f1f9;
  border-radius: 7px;
  color: #656f7d;
  padding: 14px 16px;
}

.subscription-plan-card__feedback--error {
  background-color: rgba(220, 53, 69, 0.08);
  border-color: rgba(220, 53, 69, 0.18);
  color: #b02a37;
}

.subscription-plan-card__feedback--success {
  background-color: rgba(25, 135, 84, 0.08);
  border-color: rgba(25, 135, 84, 0.18);
  color: #146c43;
}

.subscription-plan-card__current .default-btn {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 44px;
}

.payment-contact-card {
  overflow: hidden;
}

.payment-contact-card__header {
  align-items: center;
  border-bottom: 1px solid #f2f1f9;
  display: flex;
  gap: 12px;
  min-height: 64px;
  padding: 0 28px;
}

.payment-contact-card__header i {
  color: #8f9bb3;
  font-size: 22px;
}

.payment-contact-card__body {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 22px 28px 28px;
}

.payment-contact-card__body p {
  color: #656f7d;
  font-size: 14px;
  line-height: 1.45;
  margin: 0 0 4px;
}

.payment-contact-card__item {
  align-items: center;
  border: 1px solid #f2f1f9;
  border-radius: 7px;
  color: #111827;
  display: flex;
  gap: 12px;
  min-width: 0;
  padding: 14px;
  text-decoration: none;
  transition: border-color .2s ease, background-color .2s ease;
}

.payment-contact-card__item:hover {
  background-color: #f8f9fb;
  border-color: #dfe3eb;
}

.payment-contact-card__icon {
  align-items: center;
  background-color: #f8f9fb;
  border-radius: 7px;
  color: #6c63ff;
  display: flex;
  flex: 0 0 40px;
  font-size: 20px;
  height: 40px;
  justify-content: center;
  width: 40px;
}

.payment-contact-card__item--whatsapp .payment-contact-card__icon {
  background-color: rgba(25, 135, 84, 0.1);
  color: #198754;
}

.payment-contact-card__item span:last-child {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.payment-contact-card__item small {
  color: #8f9bb3;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.payment-contact-card__item strong {
  color: #111827;
  font-size: 14px;
  overflow-wrap: anywhere;
}

@media (max-width: 575px) {
  .current-invoice__amount strong {
    font-size: 26px;
  }

  .current-invoice__actions .default-btn {
    text-align: center;
    width: 100%;
  }

  .subscription-plan-card__option {
    align-items: stretch;
    flex-direction: column;
  }

  .order-summary-box.subscription-plan-card .card-checkout-title {
    height: 56px;
    padding: 0 16px;
  }

  .order-summary-box.subscription-plan-card .subscription-plan-card__body {
    gap: 16px;
    padding: 24px 16px 24px !important;
  }

  .payment-contact-card__header {
    min-height: 56px;
    padding: 0 16px;
  }

  .payment-contact-card__body {
    padding: 20px 16px 24px;
  }
}

</style>
